import { Grid, GridItem } from "@chakra-ui/react";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import CenterSpinner from "../centerSpinner";
import { ErrorBoundary } from "../errorBoundary";
import { ProblemDetailsModal } from "../problemDetailsModal/problemDetailsModal";
import { Toaster } from "../ui/toaster";

import Header from "./header/view";
import { LayoutContextProvider } from "./LayoutContextProvider";
import { useFetchAclRolesForPaths } from "./useFetchAclRolesForPaths";

const Layout = () => {
  useFetchAclRolesForPaths();
  return (
    <LayoutContextProvider>
      <Grid
        h="100vh"
        w="100vw"
        gridTemplateAreas={`'header'
                            'content'`}
        gridTemplateColumns="1fr"
        gridTemplateRows="4rem 1fr"
      >
        <GridItem area="header" position="sticky" top={0} left={0} zIndex="banner">
          <Header />
        </GridItem>

        <GridItem area="content" as="main" paddingLeft={4} paddingRight={4} overflow="auto" bg="page">
          <ErrorBoundary>
            <Suspense fallback={<CenterSpinner />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </GridItem>
      </Grid>

      <ProblemDetailsModal />

      <Toaster />
    </LayoutContextProvider>
  );
};

export default Layout;
